import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-school-not-found',
  templateUrl: './school-not-found.component.html',
  styleUrls: ['./school-not-found.component.css']
})
export class SchoolNotFoundComponent implements OnInit {
  url: string;
  constructor() { }

  ngOnInit(): void {
    this.url = window.location.hostname;
  }

}
